var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH1Bg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.453,
    height: 92,
    viewBox: "0 0 114.453 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path_24",
    "data-name": "\\u30D1\\u30B9 24",
    d: "M275.246,704.248c-3.814,12.969-16.614,28.43-55.933,28.43s-52.12-15.459-55.934-28.43c-4.218-14.339,2.589-27.684,10.241-35.441a14.813,14.813,0,0,1-5.3-4.726c-3.33-5.915-.655-13.737,5.976-17.469s14.7-1.962,18.034,3.954a13.844,13.844,0,0,1,1.292,5.911c3.459-1.247,7.016-2.261,10.706-3.244,5.108-1.362,8.386-6.354,10.343-9.335.3-.455.567-.863.809-1.211h0a4.671,4.671,0,0,1,3.836-2.008h0a4.673,4.673,0,0,1,3.835,2.01c.242.348.51.759.81,1.214,1.958,2.981,5.235,7.971,10.341,9.333,3.512.937,6.9,1.9,10.205,3.065a13.7,13.7,0,0,1,1.29-5.731c3.33-5.917,11.4-7.687,18.034-3.954s9.305,11.553,5.976,17.469a14.507,14.507,0,0,1-4.991,4.537C272.544,676.346,279.5,689.791,275.246,704.248Z",
    transform: "translate(-162.086 -640.678)",
    fill: "#231815"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH1Bg);
export default __webpack_public_path__ + "static/media/h1Bg.12cf3b6c3358fa23760fe2dbb89adb2e.svg";
export { ForwardRef as ReactComponent };